<template>
  <ModalWrapper :model-name="modelName ">
      <div class="success__registration">
        <div class="success__registration-header registration">
          <div @click="onClose" class="registration__header-close">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M18.835 18.8847C19.2832 18.4276 19.2832 17.6805 18.8438 17.2411L13.6494 12.0468L18.8438 6.84364C19.2832 6.40418 19.292 5.64832 18.835 5.20008C18.3867 4.75184 17.6309 4.75184 17.1914 5.19129L11.9971 10.3856L6.79395 5.19129C6.37207 4.76063 5.59863 4.74305 5.15039 5.20008C4.70215 5.64832 4.71094 6.42176 5.1416 6.84364L10.3359 12.0468L5.1416 17.2411C4.71094 17.6718 4.70215 18.4364 5.15039 18.8847C5.60742 19.3329 6.37207 19.3241 6.79395 18.9022L11.9971 13.6991L17.1914 18.8934C17.6309 19.3329 18.3867 19.3329 18.835 18.8847Z" />
            </svg>
          </div>
        </div>
        <div class="success__registration-body registration-body">
          <h1 class="registration-body-item p-15 mb-20 ft-size-24">
            Congratulations on registering — you’ve unlocked another <span class="green-text">free</span>  generation.
          </h1>
          <p class="registration-body-item ">
            Choose your fantasy: bikini, latex, or lingerie — and keep exploring your desires.
          </p>
          <p class="registration-body-item mt-20">
            Want to see ALL?
          </p>
          <p class="registration-body-item mt-20">
            Full nudity and access to <span class="green-text">15 sexy poses and roles</span>  become available after topping up your account.
          </p>
          <p class="registration-body-item mt-20">
            <span class="green-text">🎁 USE PROMO CODE <span class=" underline-promo" @click="copyPromoCode">{{ promoCode }}</span> WITHIN 10 MINUTES AND GET 80% OFF YOUR FIRST CREDIT PACK.</span>
          </p>

          <p class="registration__example mt-20 mb-20">
          <span class="registration__example-item">
            <img src="@/assets/cumshot/teacher.webp" alt="teacher" />
          </span>

            <span class="registration__example-item">
            <img src="@/assets/breast/nun.webp" alt="nun" />
           </span>

            <span class="registration__example-item">
            <img src="@/assets/bbc/student.webp" alt="student" />
            </span>

            <span class="registration__example-item">
            <img src="@/assets/mission/teacher.webp" alt="teacher" />
            </span>

<!--            <span class="registration__example-item">-->
<!--            <img src="@/assets/mission/nun.webp" alt="teacher" />-->
<!--            </span>-->

<!--            <span class="registration__example-item">-->
<!--            <img src="@/assets/filters-bikini/black.webp" alt="teacher" />-->
<!--            </span>-->
          </p>
          <p class="registration__example-text">
            <span class="generations-over_example-text-plus">+</span> 15more
          </p>


        </div>
        <p class="capitalize bold-attention-text-item mt-10 mb-10">🔓 What you unlock after activation:</p>
        <ul class="success__registration-list registration__list mb-20">
          <li class="registration__list-item">
            <p class="registration__list-item-text">
              ✅ Full nudity
            </p>
          </li>
          <li class="registration__list-item">
            <p class="registration__list-item-text">
              ✅ 15 seductive poses
            </p>
          </li>
          <li class="registration__list-item">
            <p class="registration__list-text">
              ✅ Characters and roles that ignite your fantasies
            </p>
          </li>
          <li class="registration__list-item">
            <p class="registration__list-item-text">
              ✅ Instant, unlimited access
            </p>
          </li>
        </ul>

        <div class="success__registration-footer registration__footer">
          <button
              @click="redirectToOrder"
              class="registration__footer-btn green-btn green-btn-with-pulse"
          >
            Top Up with Discount
          </button>

          <p class="registration__footer-promo">Promo Code: <span class="green-text underline-promo " @click="copyPromoCode">{{ promoCode }}</span> – copy and use at checkout.</p>
        </div>
      </div>
  </ModalWrapper>
</template>

<script>

import ModalWrapper from "@/components/modals/ModalWrapper.vue";
import Container from "@/components/layout-positions/Container.vue";
import {useRouter} from "vue-router";
import {useStore} from "vuex";
import {ref} from "vue";
export default {
  name: "SuccessRegistrationModal",
  components: {
    Container,
    ModalWrapper,
  },
  props: {
    modelName: {
      type: String,
    },
  },
  setup () {
    const router = useRouter();
    const store = useStore();
    const promoCode = ref('SMNKD80');

    const redirectToOrder = () => {
      router.push({
        name: "BuyCredits",
        query: { promo: promoCode.value }
      });
    };

    const onClose = () => {
      store.commit("removeAllModal");
    };

    const copyPromoCode = async () => {
      try {
        await navigator.clipboard.writeText(promoCode.value);
        store.dispatch("handleToast", {
          text: "Promo code copied!",
          type: "SUCCESS",
        });
      } catch (err) {
        console.error('Copy failed:', err);
      }
    };

    return {
      copyPromoCode,
      redirectToOrder,
      promoCode,
      onClose
    }
  }
}

</script>


<style lang="scss" scoped>
.registration {
  position: relative;
  &__header {
    &-close {
      cursor: pointer;
      position: absolute;
      right: -10px;
      top: 50%;
      transform: translateY(-50%);
      width: 40px;
      height: 38px;
      background: #ACF601;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        width: 24px;
        height: 24px;
        fill: #3E3E3E;
      }

      @media screen and (max-width: 500px) {
        width: 30px;
        height: 30px;
      }
    }
  }
  &-body {
    &-item {
      font-size: 16px;
      font-weight: bold;
      text-transform: capitalize;
      text-align: center;

      @media screen and (max-width: 740px) {
        font-size: 14px;
      }
    }
  }
}
.registration__example {
  display: flex;
  justify-content: center;
  place-items: center;
  gap: 25px;
  position: relative;

  @media screen and (max-width: 1024px) {
    gap: 15px;
  }

  &-arrow {
    width: 75px;
    height: 160px;
    position: absolute;
    top: 50%;
    left: 97%;

    @media screen and (max-width: 1024px) {
      top: 104%;
      left: 80%;
      width: 34px;
      height: 90px;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &-item {
    max-width: 120px;
    height: 160px;
    min-height: 70px;
    flex-shrink: 0;
    border-radius: 2vw;
    border: 2px solid #ACF601;
    overflow: hidden;



    @media screen and (max-width: 990px) {
      &:nth-last-child(1) {
        display: none;
      }
    }

    @media screen and (max-width: 780px) {
      &:nth-last-child(2) {
        display: none;
      }
    }

    @media screen and (max-width: 580px) {
      height: 160px;
    }


    @media screen and (min-width: 1440px) {
      border-radius: 30px;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &-text {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    span {
      color: #ACF601;
      text-align: center;
      font-size: 30px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
  }
}

.registration__list {
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  margin: 10px auto;
  max-width: 900px;

  @media screen and (max-width: 680px) {
    grid-template-columns: 1.5fr 1fr;
    gap: 5px !important;
  }

  &-item {
    p {
      font-size: 18px;
      font-weight: bold;
      text-transform: capitalize;

      @media screen and (max-width: 680px) {
        font-size: 16px;
      }

      @media screen and (max-width: 640px) {
        font-size: 12px;
      }
    }
  }
}

.registration__footer {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  &-btn {
    padding: 20px;
    font-weight: bold;
    max-width: 300px;
    font-size: 20px;
    margin-bottom: 20px;
  }

  &-promo {
    margin-bottom: 40px;
    span {
      cursor: pointer;
      text-decoration: underline;
      font-weight: bold;
    }
  }
}

.success__registration {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  margin: 0 auto;
  max-width: 718px;
  width: 95%;
  border-radius: 30px;
  background: #000;
  overflow: auto;
  max-height: 95vh;
  padding: 20px;

  &-list {
    gap: 25px;
    list-style: none;

    &-item {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 25px;

      &-icon {
        img {
          width: 30px;
          height: 30px;
        }
      }

      &-text {
        font-size: 20px;
        line-height: 100%;
        color: #FFF;
        font-style: normal;
        font-weight: bold;

        span {
          color: #ACF601;
        }
      }
    }
  }

}
</style>